import { useGtm } from '@gtm-support/vue-gtm'
import type { GA4Event } from '@/types/gtm/events'

export function useTrackEvent<T extends GA4Event>(event: T): void {
	const gtm = useGtm()
	gtm?.trackEvent(event)
}
